export default {
  'Boston College': {
    displayName: 'Boston College',
    logoUrl: 'ncaa/boston_college_eagles.webp',
  },
  California: {
    displayName: 'California',
    logoUrl: 'ncaa/california_golden_bears.webp',
  },
  Clemson: {
    displayName: 'Clemson',
    logoUrl: 'ncaa/clemson_tigers.webp',
  },
  Duke: {
    displayName: 'Duke',
    logoUrl: 'ncaa/duke_blue_devils.webp',
  },
  'Florida State': {
    displayName: 'Florida State',
    logoUrl: 'ncaa/florida_state_seminoles.webp',
  },
  'Georgia Tech': {
    displayName: 'Georgia Tech',
    logoUrl: 'ncaa/georgia_tech_yellow_jackets.webp',
  },
  Louisville: {
    displayName: 'Louisville',
    logoUrl: 'ncaa/louisville_cardinals.webp',
  },
  'Miami Florida': {
    displayName: 'Miami Florida',
    logoUrl: 'ncaa/miami_hurricanes.webp',
  },
  'NC State': {
    displayName: 'NC State',
    logoUrl: 'ncaa/nc_state_wolfpack.webp',
  },
  'North Carolina': {
    displayName: 'North Carolina',
    logoUrl: 'ncaa/north_carolina_tar_heels.webp',
  },
  'Notre Dame': {
    displayName: 'Notre Dame',
    logoUrl: 'ncaa/notre_dame_fighting_irish.webp',
  },
  Pittsburgh: {
    displayName: 'Pittsburgh',
    logoUrl: 'ncaa/pittsburgh_panthers.webp',
  },
  SMU: {
    displayName: 'SMU',
    logoUrl: 'ncaa/smu_mustangs.webp',
  },
  Stanford: {
    displayName: 'Stanford',
    logoUrl: 'ncaa/stanford_cardinal.webp',
  },
  Syracuse: {
    displayName: 'Syracuse',
    logoUrl: 'ncaa/syracuse_orange.webp',
  },
  Virginia: {
    displayName: 'Virginia',
    logoUrl: 'ncaa/virginia_cavaliers.webp',
  },
  'Virginia Tech': {
    displayName: 'Virginia Tech',
    logoUrl: 'ncaa/virginia_tech_hokies.webp',
  },
  'Wake Forest': {
    displayName: 'Wake Forest',
    logoUrl: 'ncaa/wake_forest_demon_deacons.webp',
  },
  'Coppin State': {
    displayName: 'Coppin State',
    logoUrl: 'ncaa/cse_eagles.webp',
  },
  'Delaware State': {
    displayName: 'Delaware State',
    logoUrl: 'ncaa/dsh_hornet.webp',
  },
  Howard: {
    displayName: 'Howard',
    logoUrl: 'ncaa/hb_bison.webp',
  },
  'Maryland Eastern Shore': {
    displayName: 'Maryland Eastern Shore',
    logoUrl: 'ncaa/mes_hawks.webp',
  },
  'Morgan State': {
    displayName: 'Morgan State',
    logoUrl: 'ncaa/msb_bears.webp',
  },
  'Norfolk State': {
    displayName: 'Norfolk State',
    logoUrl: 'ncaa/norfolk_state_spartans.webp',
  },
  'North Carolina Central': {
    displayName: 'North Carolina Central',
    logoUrl: 'ncaa/ncc_eagles.webp',
  },
  'South Carolina State': {
    displayName: 'South Carolina State',
    logoUrl: 'ncaa/scs_bulldogs.webp',
  },
  Akron: {
    displayName: 'Akron',
    logoUrl: 'ncaa/akron_zips.webp',
  },
  'Ball State': {
    displayName: 'Ball State',
    logoUrl: 'ncaa/ball_state_cardinals.webp',
  },
  'Bowling Green': {
    displayName: 'Bowling Green',
    logoUrl: 'ncaa/bowling_green_falcons.webp',
  },
  Buffalo: {
    displayName: 'Buffalo',
    logoUrl: 'ncaa/buffalo_bulls.webp',
  },
  'Central Michigan': {
    displayName: 'Central Michigan',
    logoUrl: 'ncaa/central_michigan_chippewas.webp',
  },
  'Eastern Michigan': {
    displayName: 'Eastern Michigan',
    logoUrl: 'ncaa/eastern_michigan_eagles.webp',
  },
  'Kent State': {
    displayName: 'Kent State',
    logoUrl: 'ncaa/kent_state_golden_flashes.webp',
  },
  Massachusetts: {
    displayName: 'Massachusetts',
    logoUrl: 'ncaa/massachusetts_minutemen.webp',
  },
  'Miami Ohio': {
    displayName: 'Miami Ohio',
    logoUrl: 'ncaa/miami_oh_redhawks.webp',
  },
  'Northern Illinois': {
    displayName: 'Northern Illinois',
    logoUrl: 'ncaa/northern_illinois_huskies.webp',
  },
  Ohio: {
    displayName: 'Ohio',
    logoUrl: 'ncaa/ohio_bobcats.webp',
  },
  Toledo: {
    displayName: 'Toledo',
    logoUrl: 'ncaa/toledo_rockets.webp',
  },
  'Western Michigan': {
    displayName: 'Western Michigan',
    logoUrl: 'ncaa/western_michigan_broncos.webp',
  },
  'Austin Peay': {
    displayName: 'Austin Peay',
    logoUrl: 'ncaa/apg_governors.webp',
  },
  Bellarmine: {
    displayName: 'Bellarmine',
    logoUrl: 'ncaa/bk_knights.webp',
  },
  'Central Arkansas': {
    displayName: 'Central Arkansas',
    logoUrl: 'ncaa/cab_bears.webp',
  },
  'Eastern Kentucky': {
    displayName: 'Eastern Kentucky',
    logoUrl: 'ncaa/ekc_colonels.webp',
  },
  'Florida Gulf Coast': {
    displayName: 'Florida Gulf Coast',
    logoUrl: 'ncaa/fgc_eagles.webp',
  },
  Jacksonville: {
    displayName: 'Jacksonville',
    logoUrl: 'ncaa/jd_dolphins.webp',
  },
  Lipscomb: {
    displayName: 'Lipscomb',
    logoUrl: 'ncaa/lb_bisons.webp',
  },
  'North Alabama': {
    displayName: 'North Alabama',
    logoUrl: 'ncaa/nal_lions.webp',
  },
  'North Florida': {
    displayName: 'North Florida',
    logoUrl: 'ncaa/nfo_ospreys.webp',
  },
  'Queens University Royals': {
    displayName: 'Queens University Royals',
    logoUrl: 'ncaa/qur_royals.webp',
  },
  Stetson: {
    displayName: 'Stetson',
    logoUrl: 'ncaa/sh_hatters.webp',
  },
  'West Georgia': {
    displayName: 'West Georgia',
    logoUrl: 'ncaa/wgw_wolves.webp',
  },
  Belmont: {
    displayName: 'Belmont',
    logoUrl: 'ncaa/bb_bruins.webp',
  },
  Bradley: {
    displayName: 'Bradley',
    logoUrl: 'ncaa/bradley_braves.webp',
  },
  Drake: {
    displayName: 'Drake',
    logoUrl: 'ncaa/db_bulldogs.webp',
  },
  Evansville: {
    displayName: 'Evansville',
    logoUrl: 'ncaa/epa_purple_aces.webp',
  },
  'Illinois State': {
    displayName: 'Illinois State',
    logoUrl: 'ncaa/isr_redbirds.webp',
  },
  'Indiana State': {
    displayName: 'Indiana State',
    logoUrl: 'ncaa/iss_sycamores.webp',
  },
  'Murray State': {
    displayName: 'Murray State',
    logoUrl: 'ncaa/msr_racers.webp',
  },
  'Northern Iowa': {
    displayName: 'Northern Iowa',
    logoUrl: 'ncaa/mip_panthers.webp',
  },
  'Southern Illinois': {
    displayName: 'Southern Illinois',
    logoUrl: 'ncaa/sis_salukis.webp',
  },
  UIC: {
    displayName: 'UIC',
    logoUrl: 'ncaa/uic_flames.webp',
  },
  Valparaiso: {
    displayName: 'Valparaiso',
    logoUrl: 'ncaa/vb_beacons.webp',
  },
  Binghamton: {
    displayName: 'Binghamton',
    logoUrl: 'ncaa/bb_bearcats.webp',
  },
  Bryant: {
    displayName: 'Bryant',
    logoUrl: 'ncaa/bb_bulldogs.webp',
  },
  Maine: {
    displayName: 'Maine',
    logoUrl: 'ncaa/mbb_black_bears.webp',
  },
  NJIT: {
    displayName: 'NJIT',
    logoUrl: 'ncaa/njit_highlanders.webp',
  },
  'New Hampshire': {
    displayName: 'New Hampshire',
    logoUrl: 'ncaa/nhw_wildcats.webp',
  },
  Albany: {
    displayName: 'Albany',
    logoUrl: 'ncaa/ua_great_danes.webp',
  },
  UMBC: {
    displayName: 'UMBC',
    logoUrl: 'ncaa/umbc_retrievers.webp',
  },
  'UMass Lowell': {
    displayName: 'UMass Lowell',
    logoUrl: 'ncaa/ulr_hawks.webp',
  },
  Vermont: {
    displayName: 'Vermont',
    logoUrl: 'ncaa/vc_catamounts.webp',
  },
  'Air Force': {
    displayName: 'Air Force',
    logoUrl: 'ncaa/aff_falcons.webp',
  },
  'Boise State': {
    displayName: 'Boise State',
    logoUrl: 'ncaa/boise_state_broncos.webp',
  },
  'Colorado State': {
    displayName: 'Colorado State',
    logoUrl: 'ncaa/colorado_state_rams.webp',
  },
  'Fresno State': {
    displayName: 'Fresno State',
    logoUrl: 'ncaa/fresno_state_bulldogs.webp',
  },
  'Grand Canyon': {
    displayName: 'Grand Canyon',
    logoUrl: 'ncaa/gcl_lopes.webp',
  },
  Nevada: {
    displayName: 'Nevada',
    logoUrl: 'ncaa/nevada_wolf_pack.webp',
  },
  'New Mexico': {
    displayName: 'New Mexico',
    logoUrl: 'ncaa/new_mexico_lobos.webp',
  },
  'San Diego State': {
    displayName: 'San Diego State',
    logoUrl: 'ncaa/san_diego_state_aztecs.webp',
  },
  'San Jose State': {
    displayName: 'San Jose State',
    logoUrl: 'ncaa/san_jose_state_spartans.webp',
  },
  UNLV: {
    displayName: 'UNLV',
    logoUrl: 'ncaa/unlv_rebels.webp',
  },
  'Utah State': {
    displayName: 'Utah State',
    logoUrl: 'ncaa/utah_state_aggies.webp',
  },
  Wyoming: {
    displayName: 'Wyoming',
    logoUrl: 'ncaa/wyoming_cowboys.webp',
  },
  'Charlotte U': {
    displayName: 'Charlotte U',
    logoUrl: 'ncaa/charlotte_49ers.webp',
  },
  'East Carolina': {
    displayName: 'East Carolina',
    logoUrl: 'ncaa/east_carolina_pirates.webp',
  },
  'Florida Atlantic': {
    displayName: 'Florida Atlantic',
    logoUrl: 'ncaa/florida_atlantic_owls.webp',
  },
  Memphis: {
    displayName: 'Memphis',
    logoUrl: 'ncaa/memphis_tigers.webp',
  },
  'North Texas': {
    displayName: 'North Texas',
    logoUrl: 'ncaa/north_texas_mean_green.webp',
  },
  Rice: {
    displayName: 'Rice',
    logoUrl: 'ncaa/rice_owls.webp',
  },
  'South Florida': {
    displayName: 'South Florida',
    logoUrl: 'ncaa/south_florida_bulls.webp',
  },
  Temple: {
    displayName: 'Temple',
    logoUrl: 'ncaa/temple_owls.webp',
  },
  Tulane: {
    displayName: 'Tulane',
    logoUrl: 'ncaa/tulane_green_wave.webp',
  },
  Tulsa: {
    displayName: 'Tulsa',
    logoUrl: 'ncaa/tulsa_golden_hurricane.webp',
  },
  UAB: {
    displayName: 'UAB',
    logoUrl: 'ncaa/uab_blazers.webp',
  },
  UTSA: {
    displayName: 'UTSA',
    logoUrl: 'ncaa/utsa_roadrunners.webp',
  },
  'Wichita State': {
    displayName: 'Wichita State',
    logoUrl: 'ncaa/wss_shockers.webp',
  },
  'Central Connecticut': {
    displayName: 'Central Connecticut',
    logoUrl: 'ncaa/cc_blue_devils.webp',
  },
  'Chicago State': {
    displayName: 'Chicago State',
    logoUrl: 'ncaa/cs_cougars.webp',
  },
  'Fairleigh Dickinson': {
    displayName: 'Fairleigh Dickinson',
    logoUrl: 'ncaa/fd_knights.webp',
  },
  'Le Moyne': {
    displayName: 'Le Moyne',
    logoUrl: 'ncaa/lm_dolphins.webp',
  },
  'Long Island University': {
    displayName: 'Long Island University',
    logoUrl: 'ncaa/li_sharks.webp',
  },
  Mercyhurst: {
    displayName: 'Mercyhurst',
    logoUrl: 'ncaa/ml_lakers.webp',
  },
  'New Haven Chargers': {
    displayName: 'New Haven Chargers',
    logoUrl: 'ncaa/nh_chargers.webp',
  },
  'Saint Francis Red Flash': {
    displayName: 'Saint Francis Red Flash',
    logoUrl: 'ncaa/sf_red_flash.webp',
  },
  Stonehill: {
    displayName: 'Stonehill',
    logoUrl: 'ncaa/ss_skyhawks.webp',
  },
  Wagner: {
    displayName: 'Wagner',
    logoUrl: 'ncaa/ws_seahawks.webp',
  },
  Davidson: {
    displayName: 'Davidson',
    logoUrl: 'ncaa/dw_wildcats.webp',
  },
  Dayton: {
    displayName: 'Dayton',
    logoUrl: 'ncaa/dayton_flyers.webp',
  },
  Duquesne: {
    displayName: 'Duquesne',
    logoUrl: 'ncaa/dd_dukes.webp',
  },
  Fordham: {
    displayName: 'Fordham',
    logoUrl: 'ncaa/fr_rams.webp',
  },
  'George Mason': {
    displayName: 'George Mason',
    logoUrl: 'ncaa/george_mason_patriots.webp',
  },
  'George Washington': {
    displayName: 'George Washington',
    logoUrl: 'ncaa/gw_revolutionaries.webp',
  },
  'La Salle': {
    displayName: 'La Salle',
    logoUrl: 'ncaa/ls_explorers.webp',
  },
  'Loyola Chicago': {
    displayName: 'Loyola Chicago',
    logoUrl: 'ncaa/lc_ramblers.webp',
  },
  'Rhode Island': {
    displayName: 'Rhode Island',
    logoUrl: 'ncaa/ri_rams.webp',
  },
  Richmond: {
    displayName: 'Richmond',
    logoUrl: 'ncaa/rs_spiders.webp',
  },
  'St. Josephs': {
    displayName: 'St. Josephs',
    logoUrl: 'ncaa/sj_hawks.webp',
  },
  'Saint Louis': {
    displayName: 'Saint Louis',
    logoUrl: 'ncaa/sl_billikens.webp',
  },
  'St. Bonaventure': {
    displayName: 'St. Bonaventure',
    logoUrl: 'ncaa/sb_bonnies.webp',
  },
  VCU: {
    displayName: 'VCU',
    logoUrl: 'ncaa/vcu_rams.webp',
  },
  'Eastern Illinois': {
    displayName: 'Eastern Illinois',
    logoUrl: 'ncaa/ei_panthers.webp',
  },
  Lindenwood: {
    displayName: 'Lindenwood',
    logoUrl: 'ncaa/ll_lions.webp',
  },
  'Little Rock': {
    displayName: 'Little Rock',
    logoUrl: 'ncaa/lr_trojans.webp',
  },
  'Morehead State': {
    displayName: 'Morehead State',
    logoUrl: 'ncaa/mr_eagles.webp',
  },
  'SIU Edwardsville': {
    displayName: 'SIU Edwardsville',
    logoUrl: 'ncaa/siu_cougars.webp',
  },
  'Southeast Missouri State': {
    displayName: 'Southeast Missouri State',
    logoUrl: 'ncaa/sm_redhawks.webp',
  },
  'Southern Indiana': {
    displayName: 'Southern Indiana',
    logoUrl: 'ncaa/si_screaming_eagles.webp',
  },
  'Tennessee State': {
    displayName: 'Tennessee State',
    logoUrl: 'ncaa/tsu_tigers.webp',
  },
  'Tennessee Tech': {
    displayName: 'Tennessee Tech',
    logoUrl: 'ncaa/tt_golden_eagles.webp',
  },
  'UT Martin': {
    displayName: 'UT Martin',
    logoUrl: 'ncaa/ut_skyhawks.webp',
  },
  'Western Illinois': {
    displayName: 'Western Illinois',
    logoUrl: 'ncaa/wi_leathernecks.webp',
  },
  'Arizona State': {
    displayName: 'Arizona State',
    logoUrl: 'ncaa/arizona_state_sun_devils.webp',
  },
  Arizona: {
    displayName: 'Arizona',
    logoUrl: 'ncaa/arizona_wildcats.webp',
  },
  BYU: {
    displayName: 'BYU',
    logoUrl: 'ncaa/byu_cougars.webp',
  },
  Baylor: {
    displayName: 'Baylor',
    logoUrl: 'ncaa/baylor_bears.webp',
  },
  Cincinnati: {
    displayName: 'Cincinnati',
    logoUrl: 'ncaa/cincinnati_bearcats.webp',
  },
  Colorado: {
    displayName: 'Colorado',
    logoUrl: 'ncaa/colorado_buffaloes.webp',
  },
  Houston: {
    displayName: 'Houston',
    logoUrl: 'ncaa/houston_cougars.webp',
  },
  'Iowa State': {
    displayName: 'Iowa State',
    logoUrl: 'ncaa/iowa_state_cyclones.webp',
  },
  Kansas: {
    displayName: 'Kansas',
    logoUrl: 'ncaa/kansas_jayhawks.webp',
  },
  'Kansas State': {
    displayName: 'Kansas State',
    logoUrl: 'ncaa/kansas_state_wildcats.webp',
  },
  'Oklahoma State': {
    displayName: 'Oklahoma State',
    logoUrl: 'ncaa/oklahoma_state_cowboys.webp',
  },
  TCU: {
    displayName: 'TCU',
    logoUrl: 'ncaa/tcu_horned_frogs.webp',
  },
  'Texas Tech': {
    displayName: 'Texas Tech',
    logoUrl: 'ncaa/texas_tech_red_raiders.webp',
  },
  'Central Florida': {
    displayName: 'Central Florida',
    logoUrl: 'ncaa/ucf_knights.webp',
  },
  Utah: {
    displayName: 'Utah',
    logoUrl: 'ncaa/utah_utes.webp',
  },
  'West Virginia': {
    displayName: 'West Virginia',
    logoUrl: 'ncaa/west_virginia_mountaineers.webp',
  },
  'American University': {
    displayName: 'American University',
    logoUrl: 'ncaa/au_eagles.webp',
  },
  Army: {
    displayName: 'Army',
    logoUrl: 'ncaa/army_black_knights.webp',
  },
  'Boston University': {
    displayName: 'Boston University',
    logoUrl: 'ncaa/bu_terriers.webp',
  },
  Bucknell: {
    displayName: 'Bucknell',
    logoUrl: 'ncaa/bucknell_bison.webp',
  },
  Colgate: {
    displayName: 'Colgate',
    logoUrl: 'ncaa/cr_raiders.webp',
  },
  'Holy Cross': {
    displayName: 'Holy Cross',
    logoUrl: 'ncaa/hc_crusaders.webp',
  },
  'UL Lafayette': {
    displayName: 'UL Lafayette',
    logoUrl: 'ncaa/lafayette_leopards.webp',
  },
  Lehigh: {
    displayName: 'Lehigh',
    logoUrl: 'ncaa/lm_hawks.webp',
  },
  'Loyola Maryland': {
    displayName: 'Loyola Maryland',
    logoUrl: 'ncaa/lm_greyhounds.webp',
  },
  Navy: {
    displayName: 'Navy',
    logoUrl: 'ncaa/navy_midshipmen.webp',
  },
  Alabama: {
    displayName: 'Alabama',
    logoUrl: 'ncaa/alabama_crimson_tide.webp',
  },
  Arkansas: {
    displayName: 'Arkansas',
    logoUrl: 'ncaa/arkansas_razorbacks.webp',
  },
  Auburn: {
    displayName: 'Auburn',
    logoUrl: 'ncaa/auburn_tigers.webp',
  },
  Florida: {
    displayName: 'Florida',
    logoUrl: 'ncaa/florida_gators.webp',
  },
  Georgia: {
    displayName: 'Georgia',
    logoUrl: 'ncaa/georgia_bulldogs.webp',
  },
  Kentucky: {
    displayName: 'Kentucky',
    logoUrl: 'ncaa/kentucky_wildcats.webp',
  },
  LSU: {
    displayName: 'LSU',
    logoUrl: 'ncaa/lsu_tigers.webp',
  },
  'Mississippi State': {
    displayName: 'Mississippi State',
    logoUrl: 'ncaa/mississippi_state_bulldogs.webp',
  },
  Missouri: {
    displayName: 'Missouri',
    logoUrl: 'ncaa/missouri_tigers.webp',
  },
  Oklahoma: {
    displayName: 'Oklahoma',
    logoUrl: 'ncaa/oklahoma_sooners.webp',
  },
  Mississippi: {
    displayName: 'Mississippi',
    logoUrl: 'ncaa/ole_miss_rebels.webp',
  },
  'South Carolina': {
    displayName: 'South Carolina',
    logoUrl: 'ncaa/south_carolina_gamecocks.webp',
  },
  Tennessee: {
    displayName: 'Tennessee',
    logoUrl: 'ncaa/tennessee_volunteers.webp',
  },
  'Texas A&M': {
    displayName: 'Texas A&M',
    logoUrl: 'ncaa/texas_a&m_aggies.webp',
  },
  Texas: {
    displayName: 'Texas',
    logoUrl: 'ncaa/texas_longhorns.webp',
  },
  Vanderbilt: {
    displayName: 'Vanderbilt',
    logoUrl: 'ncaa/vanderbilt_commodores.webp',
  },
  Butler: {
    displayName: 'Butler',
    logoUrl: 'ncaa/butler_bulldogs.webp',
  },
  Creighton: {
    displayName: 'Creighton',
    logoUrl: 'ncaa/cb_bluejays.webp',
  },
  DePaul: {
    displayName: 'DePaul',
    logoUrl: 'ncaa/dpb_blue_demons.webp',
  },
  Georgetown: {
    displayName: 'Georgetown',
    logoUrl: 'ncaa/gh_hoyas.webp',
  },
  Marquette: {
    displayName: 'Marquette',
    logoUrl: 'ncaa/mge_golden_eagles.webp',
  },
  Providence: {
    displayName: 'Providence',
    logoUrl: 'ncaa/pf_friars.webp',
  },
  'Seton Hall': {
    displayName: 'Seton Hall',
    logoUrl: 'ncaa/shp_pirates.webp',
  },
  'St. Johns': {
    displayName: 'St. Johns',
    logoUrl: 'ncaa/sj_red_storm.webp',
  },
  Connecticut: {
    displayName: 'Connecticut',
    logoUrl: 'ncaa/uconn_huskies.webp',
  },
  Villanova: {
    displayName: 'Villanova',
    logoUrl: 'ncaa/vw_wildcats.webp',
  },
  Xavier: {
    displayName: 'Xavier',
    logoUrl: 'ncaa/xm_musketeers.webp',
  },
  'Alabama A&M': {
    displayName: 'Alabama A&M',
    logoUrl: 'ncaa/am_bulldogs.webp',
  },
  'Alabama State': {
    displayName: 'Alabama State',
    logoUrl: 'ncaa/as_hornet.webp',
  },
  'Alcorn State': {
    displayName: 'Alcorn State',
    logoUrl: 'ncaa/as_braves.webp',
  },
  'Arkansas-Pine Bluff Golden Lions': {
    displayName: 'Arkansas-Pine Bluff Golden Lions',
    logoUrl: 'ncaa/ab_golden_lions.webp',
  },
  'Bethune Cookman': {
    displayName: 'Bethune Cookman',
    logoUrl: 'ncaa/bc_wildcats.webp',
  },
  'Florida A&M': {
    displayName: 'Florida A&M',
    logoUrl: 'ncaa/am_rattlers.webp',
  },
  Grambling: {
    displayName: 'Grambling',
    logoUrl: 'ncaa/gt_tigers.webp',
  },
  'Jackson State': {
    displayName: 'Jackson State',
    logoUrl: 'ncaa/jsu_tigers.webp',
  },
  'Mississippi Valley State': {
    displayName: 'Mississippi Valley State',
    logoUrl: 'ncaa/mvs_delta_devils.webp',
  },
  'Prairie View A&M': {
    displayName: 'Prairie View A&M',
    logoUrl: 'ncaa/am_panthers.webp',
  },
  Southern: {
    displayName: 'Southern',
    logoUrl: 'ncaa/sj_jaguars.webp',
  },
  'Texas Southern': {
    displayName: 'Texas Southern',
    logoUrl: 'ncaa/texas_southern_tigers.webp',
  },
  'Eastern Washington': {
    displayName: 'Eastern Washington',
    logoUrl: 'ncaa/ew_eagles.webp',
  },
  'Idaho State': {
    displayName: 'Idaho State',
    logoUrl: 'ncaa/is_bengals.webp',
  },
  Idaho: {
    displayName: 'Idaho',
    logoUrl: 'ncaa/iv_vandals.webp',
  },
  Montana: {
    displayName: 'Montana',
    logoUrl: 'ncaa/mg_grizzlies.webp',
  },
  'Montana State': {
    displayName: 'Montana State',
    logoUrl: 'ncaa/ms_bobcats.webp',
  },
  'Northern Arizona': {
    displayName: 'Northern Arizona',
    logoUrl: 'ncaa/na_lumberjacks.webp',
  },
  'Northern Colorado': {
    displayName: 'Northern Colorado',
    logoUrl: 'ncaa/nc_bears.webp',
  },
  'Portland State': {
    displayName: 'Portland State',
    logoUrl: 'ncaa/ps_vikings.webp',
  },
  'Sacramento State': {
    displayName: 'Sacramento State',
    logoUrl: 'ncaa/ss_hornet.webp',
  },
  'Weber State': {
    displayName: 'Weber State',
    logoUrl: 'ncaa/ws_wildcats.webp',
  },
  'Charleston Southern': {
    displayName: 'Charleston Southern',
    logoUrl: 'ncaa/cs_buccaneers.webp',
  },
  'Gardner-Webb': {
    displayName: 'Gardner-Webb',
    logoUrl: 'ncaa/gbr_bulldogs.webp',
  },
  Longwood: {
    displayName: 'Longwood',
    logoUrl: 'ncaa/ll_lancers.webp',
  },
  Presbyterian: {
    displayName: 'Presbyterian',
    logoUrl: 'ncaa/pbh_blue_hose.webp',
  },
  Radford: {
    displayName: 'Radford',
    logoUrl: 'ncaa/rh_highlanders.webp',
  },
  'South Carolina Upstate': {
    displayName: 'South Carolina Upstate',
    logoUrl: 'ncaa/scu_spartans.webp',
  },
  'UNC Asheville': {
    displayName: 'UNC Asheville',
    logoUrl: 'ncaa/unc_bulldogs.webp',
  },
  Winthrop: {
    displayName: 'Winthrop',
    logoUrl: 'ncaa/we_eagles.webp',
  },
  Chattanooga: {
    displayName: 'Chattanooga',
    logoUrl: 'ncaa/chattanooga_mocs.webp',
  },
  'East Tenn State': {
    displayName: 'East Tenn State',
    logoUrl: 'ncaa/ets_buccaneers.webp',
  },
  Furman: {
    displayName: 'Furman',
    logoUrl: 'ncaa/fp_paladins.webp',
  },
  Mercer: {
    displayName: 'Mercer',
    logoUrl: 'ncaa/mb_bears.webp',
  },
  Samford: {
    displayName: 'Samford',
    logoUrl: 'ncaa/sb_bulldogs.webp',
  },
  'The Citadel': {
    displayName: 'The Citadel',
    logoUrl: 'ncaa/tc_bulldogs.webp',
  },
  'UNC Greensboro': {
    displayName: 'UNC Greensboro',
    logoUrl: 'ncaa/unc_spartans.webp',
  },
  VMI: {
    displayName: 'VMI',
    logoUrl: 'ncaa/vmi_keydets.webp',
  },
  'Western Carolina': {
    displayName: 'Western Carolina',
    logoUrl: 'ncaa/wc_catamounts.webp',
  },
  Wofford: {
    displayName: 'Wofford',
    logoUrl: 'ncaa/wt_terriers.webp',
  },
  Illinois: {
    displayName: 'Illinois',
    logoUrl: 'ncaa/illinois_fighting_illini.webp',
  },
  Indiana: {
    displayName: 'Indiana',
    logoUrl: 'ncaa/indiana_hoosiers.webp',
  },
  Iowa: {
    displayName: 'Iowa',
    logoUrl: 'ncaa/iowa_hawkeyes.webp',
  },
  Maryland: {
    displayName: 'Maryland',
    logoUrl: 'ncaa/maryland_terrapins.webp',
  },
  'Michigan State': {
    displayName: 'Michigan State',
    logoUrl: 'ncaa/michigan_state_spartans.webp',
  },
  Michigan: {
    displayName: 'Michigan',
    logoUrl: 'ncaa/michigan_wolverines.webp',
  },
  Minnesota: {
    displayName: 'Minnesota',
    logoUrl: 'ncaa/minnesota_golden_gophers.webp',
  },
  Nebraska: {
    displayName: 'Nebraska',
    logoUrl: 'ncaa/nebraska_cornhuskers.webp',
  },
  Northwestern: {
    displayName: 'Northwestern',
    logoUrl: 'ncaa/northwestern_wildcats.webp',
  },
  'Ohio State': {
    displayName: 'Ohio State',
    logoUrl: 'ncaa/ohio_state_buckeyes.webp',
  },
  Oregon: {
    displayName: 'Oregon',
    logoUrl: 'ncaa/oregon_ducks.webp',
  },
  'Penn State': {
    displayName: 'Penn State',
    logoUrl: 'ncaa/penn_state_nittany_lions.webp',
  },
  Purdue: {
    displayName: 'Purdue',
    logoUrl: 'ncaa/purdue_boilermakers.webp',
  },
  Rutgers: {
    displayName: 'Rutgers',
    logoUrl: 'ncaa/rutgers_scarlet_knights.webp',
  },
  UCLA: {
    displayName: 'UCLA',
    logoUrl: 'ncaa/ucla_bruins.webp',
  },
  USC: {
    displayName: 'USC',
    logoUrl: 'ncaa/usc_trojans.webp',
  },
  Washington: {
    displayName: 'Washington',
    logoUrl: 'ncaa/washington_huskies.webp',
  },
  Wisconsin: {
    displayName: 'Wisconsin',
    logoUrl: 'ncaa/wisconsin_badgers.webp',
  },
  'East Texas A&M': {
    displayName: 'East Texas A&M',
    logoUrl: 'ncaa/et_lions.webp',
  },
  'Houston Christian': {
    displayName: 'Houston Christian',
    logoUrl: 'ncaa/hc_huskies.webp',
  },
  'Incarnate Word': {
    displayName: 'Incarnate Word',
    logoUrl: 'ncaa/iw_cardinals.webp',
  },
  Lamar: {
    displayName: 'Lamar',
    logoUrl: 'ncaa/lm_cardinals.webp',
  },
  McNeese: {
    displayName: 'McNeese',
    logoUrl: 'ncaa/mcneese_cowboys.webp',
  },
  'New Orleans': {
    displayName: 'New Orleans',
    logoUrl: 'ncaa/no_privateers.webp',
  },
  Nicholls: {
    displayName: 'Nicholls',
    logoUrl: 'ncaa/nc_colonels.webp',
  },
  'Northwestern State': {
    displayName: 'Northwestern State',
    logoUrl: 'ncaa/ns_demons.webp',
  },
  'SE Louisiana': {
    displayName: 'SE Louisiana',
    logoUrl: 'ncaa/se_lions.webp',
  },
  'Stephen F. Austin': {
    displayName: 'Stephen F. Austin',
    logoUrl: 'ncaa/sa_lumberjacks.webp',
  },
  'Texas A&M-Corpus Christi Islanders': {
    displayName: 'Texas A&M-Corpus Christi Islanders',
    logoUrl: 'ncaa/tcc_islanders.webp',
  },
  'UT Rio Grande Valley': {
    displayName: 'UT Rio Grande Valley',
    logoUrl: 'ncaa/ut_vaqueros.webp',
  },
  Denver: {
    displayName: 'Denver',
    logoUrl: 'ncaa/du_pioneers.webp',
  },
  UMKC: {
    displayName: 'UMKC',
    logoUrl: 'ncaa/kcu_roos.webp',
  },
  'North Dakota': {
    displayName: 'North Dakota',
    logoUrl: 'ncaa/nd_fighting_hawks.webp',
  },
  'North Dakota State': {
    displayName: 'North Dakota State',
    logoUrl: 'ncaa/ndsu_bison.webp',
  },
  'Nebraska Omaha': {
    displayName: 'Nebraska Omaha',
    logoUrl: 'ncaa/ou_mavericks.webp',
  },
  'Oral Roberts': {
    displayName: 'Oral Roberts',
    logoUrl: 'ncaa/oru_golden_eagles.webp',
  },
  'South Dakota': {
    displayName: 'South Dakota',
    logoUrl: 'ncaa/sdu_coyotes.webp',
  },
  'South Dakota State': {
    displayName: 'South Dakota State',
    logoUrl: 'ncaa/sdsu_jackrabbits.webp',
  },
  'St. Thomas': {
    displayName: 'St. Thomas',
    logoUrl: 'ncaa/stu_tommies.webp',
  },
  'Cal Poly': {
    displayName: 'Cal Poly',
    logoUrl: 'ncaa/cp_mustangs.webp',
  },
  'Cal State Bakersfield': {
    displayName: 'Cal State Bakersfield',
    logoUrl: 'ncaa/csu_roadrunners.webp',
  },
  'Cal State Fullerton Titans': {
    displayName: 'Cal State Fullerton Titans',
    logoUrl: 'ncaa/csu_titans.webp',
  },
  'Cal State Northridge Matadors': {
    displayName: 'Cal State Northridge Matadors',
    logoUrl: 'ncaa/csu_matadors.webp',
  },
  Hawaii: {
    displayName: 'Hawaii',
    logoUrl: 'ncaa/hawaii_rainbow_warriors.webp',
  },
  'Long Beach State': {
    displayName: 'Long Beach State',
    logoUrl: 'ncaa/lbs_beach.webp',
  },
  'UC Davis': {
    displayName: 'UC Davis',
    logoUrl: 'ncaa/uc_davis_aggies.webp',
  },
  'UC Irvine': {
    displayName: 'UC Irvine',
    logoUrl: 'ncaa/uci_anteaters.webp',
  },
  'UC Riverside': {
    displayName: 'UC Riverside',
    logoUrl: 'ncaa/ucr_highlanders.webp',
  },
  'UC San Diego': {
    displayName: 'UC San Diego',
    logoUrl: 'ncaa/ucs_tritons.webp',
  },
  'UC Santa Barbara': {
    displayName: 'UC Santa Barbara',
    logoUrl: 'ncaa/ucsb_gauchos.webp',
  },
  'Arkansas State': {
    displayName: 'Arkansas State',
    logoUrl: 'ncaa/arkansas_state_red_wolves.webp',
  },
  'Coastal Carolina': {
    displayName: 'Coastal Carolina',
    logoUrl: 'ncaa/coastal_carolina_chanticleers.webp',
  },
  'Georgia Southern': {
    displayName: 'Georgia Southern',
    logoUrl: 'ncaa/georgia_southern_eagles.webp',
  },
  'Georgia State': {
    displayName: 'Georgia State',
    logoUrl: 'ncaa/georgia_state_panthers.webp',
  },
  'James Madison': {
    displayName: 'James Madison',
    logoUrl: 'ncaa/james_madison_dukes.webp',
  },
  Louisiana: {
    displayName: 'Louisiana',
    logoUrl: 'ncaa/lu_ragin_cajuns.webp',
  },
  Marshall: {
    displayName: 'Marshall',
    logoUrl: 'ncaa/marshall_thundering_herd.webp',
  },
  'Old Dominion': {
    displayName: 'Old Dominion',
    logoUrl: 'ncaa/old_dominion_monarchs.webp',
  },
  'South Alabama': {
    displayName: 'South Alabama',
    logoUrl: 'ncaa/south_alabama_jaguars.webp',
  },
  'Southern Miss': {
    displayName: 'Southern Miss',
    logoUrl: 'ncaa/southern_miss_golden_eagles.webp',
  },
  'Texas State': {
    displayName: 'Texas State',
    logoUrl: 'ncaa/texas_state_bobcats.webp',
  },
  Troy: {
    displayName: 'Troy',
    logoUrl: 'ncaa/troy_trojans.webp',
  },
  'UL Monroe': {
    displayName: 'UL Monroe',
    logoUrl: 'ncaa/ul_monroe_warhawks.webp',
  },
  Campbell: {
    displayName: 'Campbell',
    logoUrl: 'ncaa/cu_fighting_camels.webp',
  },
  Charleston: {
    displayName: 'Charleston',
    logoUrl: 'ncaa/cu_cougars.webp',
  },
  Drexel: {
    displayName: 'Drexel',
    logoUrl: 'ncaa/du_dragons.webp',
  },
  Elon: {
    displayName: 'Elon',
    logoUrl: 'ncaa/eu_phoenix.webp',
  },
  Hampton: {
    displayName: 'Hampton',
    logoUrl: 'ncaa/hu_pirates.webp',
  },
  Hofstra: {
    displayName: 'Hofstra',
    logoUrl: 'ncaa/hu_pride.webp',
  },
  Monmouth: {
    displayName: 'Monmouth',
    logoUrl: 'ncaa/mu_hawks.webp',
  },
  'North Carolina A&T': {
    displayName: 'North Carolina A&T',
    logoUrl: 'ncaa/at_aggies.webp',
  },
  Northeastern: {
    displayName: 'Northeastern',
    logoUrl: 'ncaa/neu_huskies.webp',
  },
  'Stony Brook': {
    displayName: 'Stony Brook',
    logoUrl: 'ncaa/sbu_seawolves.webp',
  },
  Towson: {
    displayName: 'Towson',
    logoUrl: 'ncaa/tu_tigers.webp',
  },
  'NC Wilmington': {
    displayName: 'NC Wilmington',
    logoUrl: 'ncaa/unc_seahawks.webp',
  },
  'William & Mary': {
    displayName: 'William & Mary',
    logoUrl: 'ncaa/wm_tribe.webp',
  },
  'Abilene Christian': {
    displayName: 'Abilene Christian',
    logoUrl: 'ncaa/abilene_christian_wildcats.webp',
  },
  'California Baptist': {
    displayName: 'California Baptist',
    logoUrl: 'ncaa/cbu_lancers.webp',
  },
  'Southern Utah': {
    displayName: 'Southern Utah',
    logoUrl: 'ncaa/suu_thunderbirds.webp',
  },
  'Tarleton State': {
    displayName: 'Tarleton State',
    logoUrl: 'ncaa/tsu_texans.webp',
  },
  'UT Arlington': {
    displayName: 'UT Arlington',
    logoUrl: 'ncaa/uta_mavericks.webp',
  },
  'Utah Tech': {
    displayName: 'Utah Tech',
    logoUrl: 'ncaa/ut_trailblazers.webp',
  },
  'Utah Valley': {
    displayName: 'Utah Valley',
    logoUrl: 'ncaa/uvu_wolverines.webp',
  },
  Delaware: {
    displayName: 'Delaware',
    logoUrl: 'ncaa/delaware_blue_hens.webp',
  },
  'Florida International': {
    displayName: 'Florida International',
    logoUrl: 'ncaa/florida_international_panthers.webp',
  },
  'Jacksonville State': {
    displayName: 'Jacksonville State',
    logoUrl: 'ncaa/jacksonville_state_gamecocks.webp',
  },
  'Kennesaw State': {
    displayName: 'Kennesaw State',
    logoUrl: 'ncaa/kennesaw_state_owls.webp',
  },
  Liberty: {
    displayName: 'Liberty',
    logoUrl: 'ncaa/liberty_flames.webp',
  },
  'Louisiana Tech': {
    displayName: 'Louisiana Tech',
    logoUrl: 'ncaa/louisiana_tech_bulldogs.webp',
  },
  'Middle Tennessee State': {
    displayName: 'Middle Tennessee State',
    logoUrl: 'ncaa/middle_tennessee_blue_raiders.webp',
  },
  'Missouri St': {
    displayName: 'Missouri St',
    logoUrl: 'ncaa/missouri_state_bears.webp',
  },
  'New Mexico State': {
    displayName: 'New Mexico State',
    logoUrl: 'ncaa/new_mexico_state_aggies.webp',
  },
  'Sam Houston': {
    displayName: 'Sam Houston',
    logoUrl: 'ncaa/sam_houston_bearkats.webp',
  },
  UTEP: {
    displayName: 'UTEP',
    logoUrl: 'ncaa/utep_miners.webp',
  },
  'Western Kentucky': {
    displayName: 'Western Kentucky',
    logoUrl: 'ncaa/western_kentucky_hilltoppers.webp',
  },
  Gonzaga: {
    displayName: 'Gonzaga',
    logoUrl: 'ncaa/gonzaga_bulldogs.webp',
  },
  'Loyola Marymount': {
    displayName: 'Loyola Marymount',
    logoUrl: 'ncaa/lmu_lions.webp',
  },
  'Oregon State': {
    displayName: 'Oregon State',
    logoUrl: 'ncaa/oregon_state_beavers.webp',
  },
  Pacific: {
    displayName: 'Pacific',
    logoUrl: 'ncaa/pacific_tigers.webp',
  },
  Pepperdine: {
    displayName: 'Pepperdine',
    logoUrl: 'ncaa/pu_waves.webp',
  },
  Portland: {
    displayName: 'Portland',
    logoUrl: 'ncaa/pu_pilots.webp',
  },
  'San Diego': {
    displayName: 'San Diego',
    logoUrl: 'ncaa/sdu_toreros.webp',
  },
  'San Francisco': {
    displayName: 'San Francisco',
    logoUrl: 'ncaa/sfu_dons.webp',
  },
  'Santa Clara': {
    displayName: 'Santa Clara',
    logoUrl: 'ncaa/scu_broncos.webp',
  },
  'Seattle U': {
    displayName: 'Seattle U',
    logoUrl: 'ncaa/su_redhawks.webp',
  },
  'Washington State': {
    displayName: 'Washington State',
    logoUrl: 'ncaa/washington_state_cougars.webp',
  },
  'Cleveland State': {
    displayName: 'Cleveland State',
    logoUrl: 'ncaa/csu_vikings.webp',
  },
  Detroit: {
    displayName: 'Detroit',
    logoUrl: 'ncaa/dmu_titans.webp',
  },
  'Green Bay': {
    displayName: 'Green Bay',
    logoUrl: 'ncaa/gb_phoenix.webp',
  },
  'IU Indianapolis': {
    displayName: 'IU Indianapolis',
    logoUrl: 'ncaa/iu_jaguars.webp',
  },
  Milwaukee: {
    displayName: 'Milwaukee',
    logoUrl: 'ncaa/mu_panthers.webp',
  },
  'Northern Kentucky': {
    displayName: 'Northern Kentucky',
    logoUrl: 'ncaa/nku_norse.webp',
  },
  Oakland: {
    displayName: 'Oakland',
    logoUrl: 'ncaa/og_golden_grizzlies.webp',
  },
  IPFW: {
    displayName: 'IPFW',
    logoUrl: 'ncaa/pfw_mastodons.webp',
  },
  'Robert Morris': {
    displayName: 'Robert Morris',
    logoUrl: 'ncaa/robert_morris_colonials.webp',
  },
  'Wright State': {
    displayName: 'Wright State',
    logoUrl: 'ncaa/wsu_raiders.webp',
  },
  'Youngstown State': {
    displayName: 'Youngstown State',
    logoUrl: 'ncaa/ysu_penguins.webp',
  },
  Brown: {
    displayName: 'Brown',
    logoUrl: 'ncaa/bu_bears.webp',
  },
  Columbia: {
    displayName: 'Columbia',
    logoUrl: 'ncaa/cu_lions.webp',
  },
  Cornell: {
    displayName: 'Cornell',
    logoUrl: 'ncaa/cu_big_red.webp',
  },
  Dartmouth: {
    displayName: 'Dartmouth',
    logoUrl: 'ncaa/du_big_green.webp',
  },
  Harvard: {
    displayName: 'Harvard',
    logoUrl: 'ncaa/hu_crimson.webp',
  },
  Pennsylvania: {
    displayName: 'Pennsylvania',
    logoUrl: 'ncaa/pu_quakers.webp',
  },
  Princeton: {
    displayName: 'Princeton',
    logoUrl: 'ncaa/pu_tigers.webp',
  },
  Yale: {
    displayName: 'Yale',
    logoUrl: 'ncaa/yu_bulldogs.webp',
  },
  Canisius: {
    displayName: 'Canisius',
    logoUrl: 'ncaa/cu_golden_griffins.webp',
  },
  Fairfield: {
    displayName: 'Fairfield',
    logoUrl: 'ncaa/fu_stags.webp',
  },
  Iona: {
    displayName: 'Iona',
    logoUrl: 'ncaa/iona_gaels.webp',
  },
  Manhattan: {
    displayName: 'Manhattan',
    logoUrl: 'ncaa/mu_jaspers.webp',
  },
  Marist: {
    displayName: 'Marist',
    logoUrl: 'ncaa/mu_red_foxes.webp',
  },
  Merrimack: {
    displayName: 'Merrimack',
    logoUrl: 'ncaa/mu_warriors.webp',
  },
  "Mt. St. Mary's": {
    displayName: "Mt. St. Mary's",
    logoUrl: 'ncaa/msmu_mountaineers.webp',
  },
  Niagara: {
    displayName: 'Niagara',
    logoUrl: 'ncaa/nu_purple_eagles.webp',
  },
  Quinnipiac: {
    displayName: 'Quinnipiac',
    logoUrl: 'ncaa/qu_bobcats.webp',
  },
  Rider: {
    displayName: 'Rider',
    logoUrl: 'ncaa/ri_broncs.webp',
  },
  'Sacred Heart': {
    displayName: 'Sacred Heart',
    logoUrl: 'ncaa/shu_pioneers.webp',
  },
  'Saint Peters': {
    displayName: 'Saint Peters',
    logoUrl: 'ncaa/spu_peacocks.webp',
  },
  'Siena Saints': {
    displayName: 'Siena Saints',
    logoUrl: 'ncaa/su_saints.webp',
  },
  'Appalachian State': {
    displayName: 'Appalachian State',
    logoUrl: 'ncaa/appalachian_state.webp',
  },
  'MD Baltimore CO': {
    displayName: 'MD Baltimore CO',
    logoUrl: 'ncaa/md_baltimore_co.webp',
  },
  'Cal Irvine': {
    displayName: 'Cal Irvine',
    logoUrl: 'ncaa/cal_irvine.webp',
  },
  'High Point': {
    displayName: 'High Point',
    logoUrl: 'ncaa/high_point.webp',
  },
  Siena: {
    displayName: 'Siena',
    logoUrl: 'ncaa/siena.webp',
  },
  'McNeese State': {
    displayName: 'McNeese State',
    logoUrl: 'ncaa/mcneese_state.webp',
  },
  'Va Commonwealth': {
    displayName: 'Va Commonwealth',
    logoUrl: 'ncaa/va_commonwealth.webp',
  },
  'Saint Marys CA': {
    displayName: 'Saint Marys CA',
    logoUrl: 'ncaa/saint_marys_ca.webp',
  },
  'Kennesaw St': {
    displayName: 'Kennesaw St',
    logoUrl: 'ncaa/kennesaw_st.webp',
  },
  'Long Island': {
    displayName: 'Long Island',
    logoUrl: 'ncaa/long_island.webp',
  },
  'Queens NC': {
    displayName: 'Queens NC',
    logoUrl: 'ncaa/queens_nc.webp',
  },
};
